import { Injectable } from '@angular/core';
import {
  RequestEndDto,
  RequestLogDto,
  RequestStartDto,
  RequestStatusDto,
  ResponseLogDto,
  ResponseStatusDto,
  RequestSaveLogDto,
} from '../dto/tracker.dto';
import { Observable } from 'rxjs';
import { ResponseData, ResponsePaging } from '../../nest-responses';
import { NestApiProvider } from '../../nest-api';
import { RequestPagingDto } from '../dto/base.dto';

@Injectable()
export class TrackerApi {

  private readonly service: string = '';
  private readonly model: string = 'newTracker';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public status(payload?: RequestStatusDto): Observable<ResponseData<ResponseStatusDto>> {
    const method: string = 'GET';
    const func: string = 'status';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseStatusDto>>(method, url, params, urlParams, body);
  }

  public start(payload: RequestStartDto): Observable<ResponseData<string>> {
    const method: string = 'POST';
    const func: string = 'start';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<string>>(method, url, params, urlParams, body);
  }

  public end(payload: RequestEndDto[]): Observable<ResponseData<string>> {
    const method: string = 'PUT';
    const func: string = 'end';
    const params: any = payload || {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<string>>(method, url, params, urlParams, body);
  }

  public log(payload: RequestLogDto): Observable<ResponseData<ResponseLogDto>> {
    const method: string = 'GET';
    const func: string = 'log';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseLogDto>>(method, url, params, urlParams, body);
  }

  public checkTracker(): Observable<ResponseData<boolean>> {
    const method: string = 'GET';
    const func: string = 'checkTracker';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<boolean>>(method, url, params, urlParams, body);
  }

  public checkShiftTracker(): Observable<ResponseData<boolean>> {
    const method: string = 'GET';
    const func: string = 'checkShiftTracker';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<boolean>>(method, url, params, urlParams, body);
  }


  public histories(payload: RequestPagingDto) {
    const method: string = 'GET';
    const func: string = 'histories';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponsePaging<any>>(method, url, params, urlParams, body);
  }

  public saveLog(payload: RequestSaveLogDto[]) {
    const method: string = 'POST';
    const func: string = 'log';
    const params: any = payload;
    const urlParams: any = payload;
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/tracker.api.ts